import Vue from 'vue';
import Vuelidate from 'vuelidate';
import axios from 'axios';
import range from 'lodash-es/range';
import parse from 'date-fns/parse';
import format from 'date-fns/format';
import subYears from 'date-fns/sub_years';
import isBefore from 'date-fns/is_before';
import {
  required,
  helpers,
  minLength,
  maxLength,
  email
} from 'vuelidate/lib/validators';
import {
  reformatPostCode
} from '../util';
import $eventBus from '../event-bus';

/* global _as_rest */
/* eslint camelcase: 0 */

const {
  rest_url,
  rest_nonce,
  customer_hash
} = _as_rest;

Vue.use(Vuelidate);

Vue.prototype.$http = axios;

axios.defaults.headers.common['X-WP-Nonce'] = rest_nonce;
axios.defaults.headers.common['X-Customer-Hash'] = customer_hash;

const oneOf = options => value => !helpers.req(value) || options.includes(value);
const validDateOfBirth = value => !helpers.req(value) || '0000-00-00' !== value;
const maxDateOfBirth = function(value) {
  // eslint-disable-next-line yoda
  if (!helpers.req(value) || '0000-00-00' === value) {
    return true;
  }

  return isBefore(parse(value), this.meta.date_of_birth.max);
};
const phoneNumber = value => !helpers.req(value) || /^0[0-9]{10}$/.test(value);

// eslint-disable-next-line no-new
new Vue({
  el: '#as_customer_details',

  data: {
    order_state: {},
    customer: {
      name: {
        title: null,
        first_name: null,
        last_name: null
      },
      date_of_birth: {
        day: null,
        month: null,
        year: null,
        date: null
      },
      address: {
        line_1: null,
        line_2: null,
        line_3: null,
        line_4: null,
        locality: null,
        city: null,
        county: null,
        post_code: null
      },
      phone_number: null,
      email_address: null,
      password: null,
      security_identifier: null,
      direct_marketing: {
        email: null,
        phone: null,
        mail: null,
        sms: null
      }
    },
    meta: {
      address: {
        list: [],
        visible: false,
        selected: null,
        post_code_error: false,
        has_searched: false
      },
      date_of_birth: {
        max: null,
        max_formatted: null
      },
      loading: true
    }
  },

  validations: {
    customer: {
      name: {
        title: {
          required,
          oneOf: oneOf([
            'Mr',
            'Ms',
            'Miss',
            'Mrs',
            'Dr',
            'Prof'
          ])
        },
        first_name: {
          required,
          minLength: minLength(1),
          maxLength: maxLength(255)
        },
        last_name: {
          required,
          minLength: minLength(1),
          maxLength: maxLength(255)
        }
      },
      date_of_birth: {
        date: {
          required,
          validDateOfBirth,
          maxDateOfBirth
        }
      },
      address: {
        line_1: {
          required
        },
        line_2: {

        },
        line_3: {

        },
        line_4: {

        },
        locality: {

        },
        city: {
          required
        },
        county: {

        },
        post_code: {
          required
        }
      },
      phone_number: {
        required,
        phoneNumber
      },
      email_address: {
        required,
        email
      },
      /**

      password: {
        required,
        minLength: minLength(8)
      },

       */
      security_identifier: {
        required,
        minLength: minLength(8)
      },
      direct_marketing: {
        email: {
          required
        },
        mail: {
          required
        },
        phone: {
          required
        },
        sms: {
          required
        }
      }
    }
  },

  created() {
    this.meta.date_of_birth.max = subYears(new Date(), 18);
    this.meta.date_of_birth.max_formatted = format(this.meta.date_of_birth.max, 'Do MMMM YYYY');
  },

  mounted() {
    $eventBus.$emit('mounted', this);
  },

  computed: {
    days() {
      return range(1, 32);
    },
    months() {
      return range(1, 12);
    },
    years() {
      let year = new Date().getFullYear();

      return range(year, year - 100);
    },
    formatted_date_of_birth() {
      if (this.customer.date_of_birth.date) {
        return format(parse(this.customer.date_of_birth.date), 'Do MMMM YYYY');
      }
    }
  },

  watch: {
    'customer.date_of_birth.day'() {
      this.update_date_of_birth();
    },
    'customer.date_of_birth.month'() {
      this.update_date_of_birth();
    },
    'customer.date_of_birth.year'() {
      this.update_date_of_birth();
    },
    'customer.address.post_code'() {
      this.meta.address.post_code_error = false;
    },
    'meta.address.selected'(index) {
      let address = {};

      if (null !== index && this.meta.address.list[index]) {
        address = this.meta.address.list[index];
      }

      this.customer.address.line_1 = address.line_1 || null;
      this.customer.address.line_2 = address.line_2 || null;
      this.customer.address.line_3 = address.line_3 || null;
      this.customer.address.line_4 = address.line_4 || null;
      this.customer.address.locality = address.locality || null;
      this.customer.address.city = address.city || null;
      this.customer.address.county = address.county || null;

      this.meta.address.visible = true;
    },
    // eslint-disable-next-line complexity
    'order_state.customer'(customer = {}) {
      if (!this.order_state.customer || (!this.order_state.customer.customer_hash && !this.order_state.customer.id)) {
        return;
      }

      this.customer.id = customer.id || null;
      this.customer.name.title = customer.name.title || null;
      this.customer.name.first_name = customer.name.first_name || null;
      this.customer.name.last_name = customer.name.last_name || null;
      this.customer.address.line_1 = customer.address.line_1 || null;
      this.customer.address.line_2 = customer.address.line_2 || null;
      this.customer.address.line_3 = customer.address.line_3 || null;
      this.customer.address.line_4 = customer.address.line_4 || null;
      this.customer.address.locality = customer.address.locality || null;
      this.customer.address.city = customer.address.city || null;
      this.customer.address.county = customer.address.county || null;
      this.customer.address.post_code = customer.address.post_code || null;
      this.customer.email_address = customer.email_address || null;
      this.customer.security_identifier = customer.security_identifier || null;

      if (this.customer.address.post_code) {
        this.meta.address.visible = true;
      }

      customer.direct_marketing = customer.direct_marketing || {};

      [
        'email',
        'phone',
        'mail',
        'sms'
      ].forEach(key => {
        let value = customer.direct_marketing[key];

        if (true !== value && false !== value) {
          value = null;
        }

        this.customer.direct_marketing[key] = value;
      });

      if (customer.contacts && 1 === Object.keys(customer.contacts).length) {
        this.customer.phone_number = customer.contacts[Object.keys(customer.contacts).shift()] || null;
      }

      if (customer.date_of_birth) {
        this.customer.date_of_birth.date = customer.date_of_birth;
        this.customer.date_of_birth.day = parseInt(format(parse(customer.date_of_birth), 'D'), 10);
        this.customer.date_of_birth.month = parseInt(format(parse(customer.date_of_birth), 'M'), 10);
        this.customer.date_of_birth.year = parseInt(format(parse(customer.date_of_birth), 'YYYY'), 10);
      }
    }
  },

  methods: {
    query_post_code() {
      let {
        address: {
          post_code
        }
      } = this.customer;

      this.$v.customer.address.post_code.$touch();

      if (!post_code) {
        return;
      }

      this.meta.address.post_code_error = false;
      this.customer.address.post_code = reformatPostCode(post_code);

      this
        .$http({
          method: 'GET',
          url: `${rest_url}wp-asurit-sales/v1/helpers/address-query?post_code=${post_code.replace(/[^0-9a-zA-z]/g, '')}`
        })
        .then(({ data: { addresses = [] } }) => {
          this.meta.address.has_searched = true;
          this.meta.address.selected = null;
          this.meta.address.list = addresses;
        })
        .catch(error => {
          let data = error.response && error.response.data || { message: 'Unknown error' };

          this.meta.address.has_searched = true;
          this.meta.address.post_code_error = data.message || 'Unknown error';
          this.meta.address.selected = null;
          this.meta.address.list = [];
        })
      ;
    },
    update_date_of_birth() {
      const {
        date_of_birth: {
          day,
          month,
          year
        }
      } = this.customer;

      // eslint-disable-next-line yoda
      if (null === day || month === null || year === null) {
        return this.customer.date_of_birth.date = null;
      }

      let date = parse(`${year}/${month}/${day}`);

      this.$v.customer.date_of_birth.date.$touch();

      if (month - 1 !== date.getMonth()) {
        this.customer.date_of_birth.date = '0000-00-00';
      } else {
        this.customer.date_of_birth.date = format(date, 'YYYY-MM-DD');
      }
    },
    next() {
      if (this.$v.$invalid) {
        this.meta.address.visible = true;
        this.$v.customer.name.title.$touch();
        this.$v.customer.name.first_name.$touch();
        this.$v.customer.name.last_name.$touch();
        this.$v.customer.date_of_birth.date.$touch();
        this.$v.customer.address.line_1.$touch();
        this.$v.customer.address.line_2.$touch();
        this.$v.customer.address.line_3.$touch();
        this.$v.customer.address.line_4.$touch();
        this.$v.customer.address.locality.$touch();
        this.$v.customer.address.city.$touch();
        this.$v.customer.address.county.$touch();
        this.$v.customer.address.post_code.$touch();
        this.$v.customer.phone_number.$touch();
        this.$v.customer.email_address.$touch();
        // this.$v.customer.password.$touch();
        this.$v.customer.security_identifier.$touch();
        this.$v.customer.direct_marketing.email.$touch();
        this.$v.customer.direct_marketing.mail.$touch();
        this.$v.customer.direct_marketing.phone.$touch();
        this.$v.customer.direct_marketing.sms.$touch();

        $eventBus.$emit('has-error');

        return;
      }

      this
        .$http({
          method: 'POST',
          url: `${rest_url}wp-asurit-sales/v1/customers`,
          data: {
            email_address: this.customer.email_address,
            password: this.customer.password || '-not-used-yet-',
            name: {
              ...this.customer.name
            },
            address: {
              ...this.customer.address
            },
            date_of_birth: this.customer.date_of_birth.date,
            contacts: {
              [/^07/.test(this.customer.phone_number) ? 'mobile_phone' : 'home_phone']: this.customer.phone_number
            },
            security_identifier: this.customer.security_identifier,
            direct_marketing: {
              ...this.customer.direct_marketing
            }
          }
        })
        .then(({ data }) => {
          let emit = {
            completed: 'customer-details',
            customer: {
              ...data.customer
            }
          };

          $eventBus.$emit('order-updated', emit);
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error.message || error);
        })
      ;
    },
    edit() {
      $eventBus.$emit('order-updated', { edit: 'customer-details' });
    }
  }
});

